<template>
    <svg :cssClass="cssClass" :class="iconCssClass" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 16L17 1L9.5 8.5L2 1L17 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
    <filter id="filter0_d" x="0" y="0" width="19" height="19" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="0.5"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
    </defs>
    </svg>
</template>

<script>
export default {

	props: {
		cssClass: {
			type: String,
			default: () => '',
		},
    },

    computed: {

        iconCssClass()
        {
            return `icon-svg ${this.cssClass} icon-svg--close`
        },

    },

}
</script>

<style lang="scss">
.icon-svg {
    &.icon-svg--close {
        width: 15px;
        height: 15px;
        color: black;

        &:hover {
            color: #EB5757;
        }
    }
}
</style>
